import React, { forwardRef } from 'react'

import { IconProps } from './types'

const Lock = forwardRef<SVGSVGElement, IconProps>(
  ({ color, size, ...props }, ref) => (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 2.5C6.61929 2.5 5.5 3.61929 5.5 5V6H4.5V5C4.5 3.067 6.067 1.5 8 1.5C9.933 1.5 11.5 3.067 11.5 5V6H10.5V5C10.5 3.61929 9.38071 2.5 8 2.5Z"
        fill={color || 'currentColor'}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13 6H3V14H13V6ZM8.5 8.5H7.5V11.5H8.5V8.5Z"
        fill={color || 'currentColor'}
      />
    </svg>
  ),
)
Lock.displayName = 'Lock'

export default Lock
